import {Component, OnDestroy, OnInit} from '@angular/core';
import {IResource} from "../../../models/ressources/i-resource";
import {BasicResource} from "../../../models/ressources/basic-resource";
import {faTrash, faPlus, faClipboard} from "@fortawesome/free-solid-svg-icons";
import {AuthentificationService} from "../../../services/authentification.service";
import {BehaviorSubject, firstValueFrom, Subject, takeUntil} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Clipboard} from "@angular/cdk/clipboard";
import {MatDialog} from "@angular/material/dialog";
import {CreateCustomResourceComponent} from "../create-custom-resource/create-custom-resource.component";
import {DatabaseService} from "../../../services/db/database.service";
import {DbKeys} from "../../../services/db/config/db-config";
import {FileService} from "../../../services/file/file.service";
import {ConfirmationDialogComponent} from "../../utils/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: 'app-custom-ressource-list',
  templateUrl: './custom-resource-list.component.html',
  styleUrls: ['./custom-resource-list.component.scss'],
  host: {'class': 'base-host-center styled-background'},
})
export class CustomResourceListComponent implements OnInit, OnDestroy {
  protected resources: IResource[]
  private readonly destroy$ = new Subject<boolean>();
  protected isAuthenticated$: BehaviorSubject<boolean>;
  protected readonly faTrash = faTrash
  protected readonly faPlus = faPlus
  protected readonly faClipboard = faClipboard

  constructor(
    private readonly authService: AuthentificationService,
    private readonly snackbar: MatSnackBar,
    private readonly clipboard: Clipboard,
    private readonly matDialog: MatDialog,
    private readonly db: DatabaseService,
    private readonly fileService: FileService,
  ) {}

  ngOnInit(): void {
    this.isAuthenticated$ = this.authService.isAuthenticated$
    this.loadResources();
  }

  private loadResources() {
    this.db.getdata(DbKeys.customResources)
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => this.resources = data.map(item => {
        const id = item.payload.doc.id;
        const data = item.payload.doc.data() as any;

        return new BasicResource(id, data.url, data.name);
      }));

  }

  copyUrl(resource: IResource) {
    this.clipboard.copy(resource.getResourceUrl());
    this.snackbar.open('Lien copié !', 'Fermer', {
      duration: 5000,
    });
  }

   openDeleteDialog(resource: IResource) {
    console.log("Start delete")
    this.matDialog.open(ConfirmationDialogComponent, {
      width: '250px',
      data: {
        title: 'Supprimer ressource',
        message: 'Le fichier sera supprimé définitivement',
        acceptButton: 'Supprimer',
        rejectButton: 'Annuler',
        onAccept: async() => {await this.deleteResource(resource)}
      }
    })
  }

  async deleteResource(resource: IResource): Promise<void> {
    // Try deleting the file, but continue even if it fails
    try {
      await firstValueFrom(this.fileService.deleteFile(resource.getResourceUrl()));
    } catch (error) {
      this.onStorageDeleteError(error);
    }

    // Delete the resource from the database
    try {
      await this.db.deleteData(DbKeys.customResources, resource.getResourceId());
      this.onResourceDeleted(resource);
    } catch (error) {
      this.onDbDeleteError(error);
    }
  }


  private onResourceDeleted(resource: IResource): void {
    this.resources = this.resources.filter(item => item.getResourceId() !== resource.getResourceId());
    this.snackbar.open('Ressource supprimée !', 'Fermer', {duration: 5000});
  }

  private onStorageDeleteError(error: any) {
    this.snackbar.open(
      `Erreur lors de la suppression du fichier. Suppression du ficher : ${error}`,
      'Fermer',
      {duration: 5000}
    );
  }

  private onDbDeleteError(error: any): void {
    this.snackbar.open(
      `Erreur lors de la suppression en base de données : ${error}`,
      'Fermer',
      {duration: 5000}
    );
  }


  openAddResourceDialog() {
    this.matDialog.open(CreateCustomResourceComponent);

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
